export enum CustomEpubCursorStyles {
    erase = 'erase',
    textnote = 'textnote',
    stickynote = 'stickynote',
    audiomaker = 'audiomaker',
    yellow = 'yellow',
    orange = 'orange',
    green = 'green',
    blue = 'blue',
    pink = 'pink'
}

export enum EpubAnnotationMode {
    Marker = 'Marker',
    Eraser = 'Eraser',
    Textnote = 'Textnote',
    None = 'None'
}

export enum EpubStrokeColor {
    LightBlue = '#80DCFF',
    Blue = '#0075DA',
    DarkBlue = '#00193D',
    LightGreen = '#01FF70',
    Green = '#2ACD3D',
    DarkGreen = '#3A9A70',
    Yellow = '#FFDD00',
    Orange = '#FF8614',
    Red = '#FF0000',
    Pink = '#F009BF',
    Purple = '#B206CA',
    DarkPurple = '#860C4A',
    LightGray = '#DEDEDE',
    Gray = '#ABACAC',
    Black = '#080808'
}